// @@flow
const UPDATE_PAIRS = '@@amazon_md/ui/update_pairs';

const initialState = {
  isLoading: false,
};

const ui = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAIRS: {
      return {
        ...state,
        ...action.pairs,
      };
    }
    default:
      return state;
  }
};

export const updateUIPairs = pairs => ({
  type: UPDATE_PAIRS,
  pairs,
});

export default ui;
